export const TAG_SIMULACAO_LABEL = "Simulação";
